import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

const programDays = [
  {
    key: 'sunday',
    tab: 'Sun, 5 Sep',
    title: 'Sunday, 5 September 2027',
    items: [
      {
        time: '19:00',
        title: 'Ice Breaker',
        type: 'social',
      },
    ],
  },
  {
    key: 'monday',
    tab: 'Mon, 6 Sep',
    title: 'Monday, 6 September 2027',
    items: [
      {
        time: '08:30',
        title: 'Opening Ceremony',
        type: 'ceremony',
      },
      {
        time: '08:45',
        title: 'Plenary Lecture',
        type: 'plenary',
      },
      {
        time: '09:45',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '10:15',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['4 oral presentations'],
      },
      {
        time: '11:15',
        title: 'Break',
        type: 'break',
      },
      {
        time: '11:30',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['4 oral presentations'],
      },
      {
        time: '12:30',
        title: 'Lunch Break',
        type: 'break',
      },
      {
        time: '13:30',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['6 oral presentations'],
      },
      {
        time: '15:00',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '15:30',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['5 oral presentations'],
      },
      {
        time: '16:45',
        title: 'Break',
        type: 'break',
      },
      {
        time: '17:00',
        title: 'Poster Session',
        type: 'poster',
        details: ['Refreshments included'],
      },
      {
        time: '19:00',
        title: 'GAeF Welcome Event',
        type: 'social',
      },
    ],
  },
  {
    key: 'tuesday',
    tab: 'Tue, 7 Sep',
    title: 'Tuesday, 7 September 2027',
    items: [
      {
        time: '08:45',
        title: 'Plenary Lecture',
        type: 'plenary',
      },
      {
        time: '09:45',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '10:15',
        title: 'Working Group Keynote and Meeting, Parallel Oral Sessions',
        type: 'meeting',
        details: ['WG1 Keynote & Meeting', '4 oral presentations'],
      },
      {
        time: '11:15',
        title: 'Break',
        type: 'break',
      },
      {
        time: '11:30',
        title: 'Working Group Keynote and Meeting, Parallel Oral Sessions',
        type: 'meeting',
        details: ['WG2 Keynote & Meeting', '4 oral presentations'],
      },
      {
        time: '12:30',
        title: 'Lunch Break',
        type: 'break',
        details: ['EAA meeting'],
      },
      {
        time: '13:30',
        title: 'Poster Session',
        type: 'poster',
      },
      {
        time: '15:00',
        title: 'Coffee Break',
        type: 'break',
        details: ['Group photo'],
      },
      {
        time: '15:30',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['5 oral presentations'],
      },
      {
        time: '16:45',
        title: 'Break',
        type: 'break',
      },
      {
        time: '17:00',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['6 oral presentations'],
      },
      {
        time: '19:00',
        title: 'Young Investigator Network',
        type: 'social',
        details: ['YIN event'],
      },
    ],
  },
  {
    key: 'wednesday',
    tab: 'Wed, 8 Sep',
    title: 'Wednesday, 8 September 2027',
    items: [
      {
        time: '07:00',
        title: 'EAC Fun Run',
        type: 'social',
      },
      {
        time: '08:45',
        title: 'Plenary Lecture',
        type: 'plenary',
      },
      {
        time: '09:45',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '10:15',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['4 oral presentations'],
      },
      {
        time: '11:15',
        title: 'Break',
        type: 'break',
      },
      {
        time: '11:30',
        title: 'Working Group Keynote and Meeting, Parallel Oral Sessions',
        type: 'oral',
        details: ['WG3 Keynote & Meeting', '4 oral presentations'],
      },
      {
        time: '12:30',
        title: 'Refreshments',
        type: 'break',
      },
      {
        time: '13:00',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['5 oral presentations'],
      },
      {
        time: '14:30',
        title: 'Meetings and Facultative Activities',
        type: 'social',
        details: ['Scientific excursions', 'Companies hands on', 'ACTRIS meeting', 'Other meetings', 'Sightseeing', 'Tourist tours'],
      },
    ],
  },
  {
    key: 'thursday',
    tab: 'Thu, 9 Sep',
    title: 'Thursday, 9 September 2027',
    items: [
      {
        time: '08:45',
        title: 'Plenary Lecture',
        type: 'plenary',
      },
      {
        time: '09:45',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '10:15',
        title: 'Working Group Keynote and Meeting, Parallel Oral Sessions',
        type: 'oral',
        details: ['WG4 Keynote & Meeting', '4 oral presentations'],
      },
      {
        time: '11:15',
        title: 'Break',
        type: 'break',
      },
      {
        time: '11:30',
        title: 'Working Group Keynote and Meeting, Parallel Oral Sessions',
        type: 'oral',
        details: ['WG5 Keynote & Meeting', '4 oral presentations'],
      },
      {
        time: '12:30',
        title: 'Lunch Break',
        type: 'break',
      },
      {
        time: '13:30',
        title: 'Poster Session',
        type: 'poster',
      },
      {
        time: '15:00',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '15:30',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['5 oral presentations'],
      },
      {
        time: '16:45',
        title: 'Break',
        type: 'break',
      },
      {
        time: '17:45',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['6 oral presentations'],
      },
      {
        time: '19:00',
        title: 'Conference Dinner',
        type: 'social',
      },
      {
        time: '22:30',
        title: 'Conference Party',
        type: 'social',
        details: ['All'],
      },
      
    ],
  },
  {
    key: 'friday',
    tab: 'Fri, 10 Sep',
    title: 'Friday, 10 September 2027',
    items: [
      {
        time: '08:45',
        title: 'Plenary Lecture',
        type: 'plenary',
      },
      {
        time: '09:45',
        title: 'Award Ceremony',
        type: 'ceremony',
      },
      {
        time: '10:15',
        title: 'Coffee Break',
        type: 'break',
      },
      {
        time: '10:30',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['4 oral presentations'],
      },
      {
        time: '11:30',
        title: 'Break',
        type: 'break',
      },
      {
        time: '11:45',
        title: 'Parallel Oral Sessions',
        type: 'oral',
        details: ['5 oral presentations'],
      },
      {
        time: '13:30',
        title: 'Closing Ceremony',
        type: 'ceremony',
      },
    ],
  },
];



function ProgramTimeline({ items }) {
  return (
    <div className="program-timeline">
      {items.map((item, index) => (
        <article className={`program-item program-item-${item.type}`} key={`${item.time}-${item.title}-${index}`}>
          <div className="program-time">{item.time}</div>

          <div className="program-content">
            

            <h3>{item.title}</h3>

            {item.details && (
              <div className="program-details">
                {item.details.map((detail) => (
                  <span key={detail}>{detail}</span>
                ))}
              </div>
            )}
          </div>
        </article>
      ))}
    </div>
  );
}

export default function InfoTentativeProgram() {
  const [activeDay, setActiveDay] = useState(programDays[1].key);
  const currentDay = programDays.find((day) => day.key === activeDay);

  return (
    <div className="page-content">
      <PageHero
        eyebrow="Conference info"
        title="Tentative Programme"
        intro="The programme of EAC2027 traditionally combines scientific presentations with community meetings and social events."
        action={
          <a
            href="/documents/EAC2027-tentative-programme.pdf"
            target="_blank"
            rel="noreferrer"
            className="btn btn-eac-pink btn-lg text-white"
          >
            Download programme
          </a>
        }
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className="h1">Whole year of aerosol research in a week</h2>
                <p>
                  The programme of EAC2027 below is tentative and may be updated as the conference schedule develops. Please consult
                  the final conference programme for confirmed times, rooms and session details.
                </p>
              </section>
            </Col>
          </Row>

          <Row>
            <Col>
              <section className="info-section pt-5">
                <div className="program-tabs" role="tablist" aria-label="Tentative programme days">
                  {programDays.map((day) => (
                    <button
                      key={day.key}
                      type="button"
                      className={`program-tab ${activeDay === day.key ? 'active' : ''}`}
                      onClick={() => setActiveDay(day.key)}
                      role="tab"
                      aria-selected={activeDay === day.key}
                    >
                      {day.tab}
                    </button>
                  ))}
                </div>

                <div className="program-day-heading">
                  <h2>{currentDay.title}</h2>
                </div>

                <ProgramTimeline items={currentDay.items} />
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}